import { render, staticRenderFns } from "./insurance-ad-list.vue?vue&type=template&id=f357adc8&scoped=true"
import script from "./insurance-ad-list.vue?vue&type=script&lang=js"
export * from "./insurance-ad-list.vue?vue&type=script&lang=js"
import style0 from "./insurance-ad-list.vue?vue&type=style&index=0&id=f357adc8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f357adc8",
  null
  
)

export default component.exports